import jQuery from 'jquery';
import {AppearObserver} from "./widget/appear-observer";
import {ViewportObserver} from "./widget/viewport-observer";
import {StickyObserver} from "./widget/sticky-observer";

jQuery.widget('omni.appearObserver', AppearObserver);
jQuery.widget('omni.stickyObserver', StickyObserver);
jQuery.widget('omni.viewportObserver', ViewportObserver);

